var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPandaSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0{fill:#FFFFFF;}\n\t.st1{fill:#47B972;}\n ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_on_black-alpha"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "mark_white"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mark_8_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_616_",
    className: "st0",
    width: 80,
    height: 80
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_614_",
    className: "st1",
    d: "M58.5,17.7v11.8l-0.2,0.1c-1.7-1.4-3.9-2.3-6.7-2.3c-3.6,0-6.9,1.3-9.1,3.9l3.4,3.6 c1.7-1.6,3.5-2.5,5.8-2.5c4.3,0.1,7.1,3.4,7.1,7.8c0,4.4-2.9,7.8-7.3,7.8c-11,0-7.9-20.6-22.7-20.6c-7.4,0-12.6,5.5-12.6,12.8 v22.3h5.3V50.5l0.2-0.1c1.7,1.4,3.9,2.3,6.7,2.3c3.6,0,6.9-1.3,9.1-3.9l-3.4-3.6c-1.7,1.6-3.5,2.5-5.8,2.5 c-4.3-0.1-7.1-3.4-7.1-7.8c0-4.4,2.9-7.8,7.3-7.8c11,0,7.9,20.6,22.7,20.6c7.4,0,12.6-5.5,12.6-12.8V17.7H58.5z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "logo_on_green-alpha"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandaSvg);
export default __webpack_public_path__ + "static/media/pandaSVG.49971281a959a42ae3de109ff9d0ef62.svg";
export { ForwardRef as ReactComponent };